import React from "react";
import Form from "./components/Form";
import ContentHeader from "../../components/ContentHeader";
import { ReactComponent as ProfileLogo } from "../../components/ContentHeader/assets/images/profile.svg";

const Profile: React.FC = () => {
  return (
    <main className="wrapperApp">
      <ContentHeader
        title="My Profile"
        Icon={ProfileLogo}
        breadcrumb={["My Profile"]}
      />
      <div id="content" className="profile">
        <section className="content__block">
          <div className="content__header">
            <h2 className="content__title">PROFILE DETAILS</h2>
          </div>
          <Form />
        </section>
      </div>
    </main>
  );
};
export default Profile;
